<template>
    <div class="searchWrapper">
        <div class="searchInner">
            <div class="searchField">
                <tags-input element-id="filter_description"
                            v-model="filter_keywords"
                            :typeahead="false"
                            placeholder="Meklē pēc nosaukuma, apraksta, kolekcijas, numura, autora, materiāla..."
                            :add-tags-on-comma="true"
                            :add-tags-on-blur="true"
                ></tags-input>
            </div>
            <div class="searchButtons">
                <button class="btn btn-lg" v-if="loading == true" disabled><span class="material-icons">search</span>Meklē</button>
                <button class="btn btn-lg" v-else @click="search(1)"> <span class="material-icons">search</span>Meklēt</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted()
    {
        var public_filter = localStorage.getItem('public_filter');
        var public_filter_object = JSON.parse(public_filter);
        if(public_filter_object)
        {
            this.filter_keywords = public_filter_object.keywords;
            this.current_page = public_filter_object.page;
        }

        this.search(this.current_page);
        var that = this;
        EventBus.$on('change_page', page =>{
            that.search(page);
        })
    },
    data(){
        return{
            loading:false,
            filter_keywords: [],
            filter_loading:[],
            current_page:1,
        }
    },
    methods:{
        search(page = 1)
        {

            EventBus.$emit('search_started');
            var that = this;
            this.loading = true;
            var filterData = {
                keywords:that.filter_keywords,
                page:page,
                items_per_page: that.filter_items_per_page,
            };
            localStorage.setItem('public_filter', JSON.stringify(filterData));


            axios.post('/get-items',filterData).then(response =>{
                if (response.data.status == 'ok')
                {
                    that.loading = false;
                    if(response.data.type == 'get_search_results')
                    {
                        EventBus.$emit('items_loaded', response.data);
                        that.loading = false;
                    }
                }
            })
        },
    }
}
</script>

<style lang="scss">
.searchWrapper{
    background:#fefefe;
    width:100%;
    margin:auto;
    padding:10px 20px;
    position:sticky;
    z-index:21;
    top:80px;
    left:0;
    box-shadow: rgb(0 0 0 / 8%) 0px 15px 25px, rgb(0 0 0 / 5%) 0px 5px 10px;
    .searchInner{
        width:800px;
        max-width:100%;
        margin:auto;
        display:flex;
        align-items: center;
        .tags-input-wrapper-default{
            border:solid 1px #aaa;
            border-radius:5px;
            font-size:16px;
            @media(max-width:768px)
            {
                font-size:12px;
            }
            &.active{
                border:solid 1px #aaa;
                box-shadow:none;
            }
        }
        .tags-input-remove:before, .tags-input-remove:after {
            background: #392e2d;
        }
        .tags-input-remove:before {
            -webkit-transform: rotate(
                    45deg);
            transform: rotate(
                    45deg);
        }
        .searchField{
            flex-grow:1;
        }
        .searchButtons{
            @media (max-width: 768px) {
                .btn {
                    font-size:11px;
                    padding:4px 6px;
                }
            }
            display:flex;
            justify-content: center;
            align-items: center;
            button{
                margin:5px 15px;
                background:#d03d27;
                color:#fff;
                display:flex;
                align-items: center;
            }
        }
    }
}
</style>
